import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { ensureArray } from 'cityads-v3/utils/arrayUtils';

import OfferCard from '../offers/OfferCard';
import CouponExportPopup from './CouponExportPopup';

import classes from './CouponCard.scss';

import { loadCouponLink } from 'cityads-v3/actions/offers';

export const offerOptions = (t, props) => [
  {
    title: t('table.period'),
    name: 'period',
    start: 'start_date',
    end: 'end_date',
    format: 'period'
  }, {
    title: t('table.promocode'),
    name: 'promocode',
    format: 'notBlank'
  }, {
    title: t('table.promo_action_type'),
    name: 'promo_action_type',
    formatter: value => props.promoActionTypesById ? props.promoActionTypesById.title : '-'
  }, {
    title: t('table.promo_coupon_scope'),
    name: 'promo_coupon_scope',
    formatter: value => props.promoCouponScopesById ? props.promoCouponScopesById.title : '-'
  }, {
    title: t('table.promo_action_status'),
    name: 'status',
    formatter: value => {
      return props.status.map(id => props.promoCouponStatusesById[id] ? props.promoCouponStatusesById[id].title : '-').join(', ');
    }
  }, {
    title: t('table.couponLanguage'),
    name: 'language_id',
    formatter: value => {
      return ensureArray(props.language_id).map(id => props.promoCouponLanguagesById[id] ? props.promoCouponLanguagesById[id].title : '-').join(', ');
    }
  },
];

@connect(
  (state, props) => ({
    couponOffersById: state.offers.couponOffersById,
    promoActionTypesById: state.offers.promoActionTypesById[props.promo_action_type],
    promoCouponStatusesById: state.offers.promoCouponStatusesById,
    promoCouponScopesById: state.offers.promoCouponScopesById[props.promo_coupon_scope],
    promoCouponLanguagesById: state.language.sadukaLanguagesById,
  })
)
@withTranslation(['Offers'], { i18n, wait: !!window })
export default class CouponCard extends Component {

  static propTypes = {
    couponOffersById: PropTypes.object,
    promoActionTypesById: PropTypes.object,
    couponLinksByCouponId: PropTypes.object,
  }

  state = {
    showExportPopup: false
  }

  getOfferInfo(id) {
    const { couponOffersById } = this.props;
    const offer = couponOffersById?.[id];

    if (!offer) {
      return null;
    }

    return {
      offerId: offer.id,
      offerName: offer.name,
      offerIsDeeplinkEnabled: offer.is_deeplink_enabled,
    };
  }

  getOptions = (t) => {
    return (t) => offerOptions(t, this.props);
  }

  showExportPopup = () => {
    this.setState({
      showExportPopup: true
    });

    this.props.dispatch(loadCouponLink( this.props.id ));
  }

  render() {
    const actions = [{
      title   : this.props.t('link'),
      variant : 'contained',
      onClick : () => this.showExportPopup()
    }];

    const offerInfo = this.getOfferInfo(this.props.offer);

    return (
      <div>
        <OfferCard
          {...this.props}
          regions={this.props.geos}
          className={classNames(classes.couponCard, { [classes['couponCard--exclusive']]: this.props.is_exclusive })}
          options={this.getOptions()}
          business_category={this.props.category}
          showId={false}
          showOffer={true}
          showTargetsTable={false}
          descriptionInTheMiddle={true}
          customActions={actions}
          isCoupon
          manualFetch
          {...offerInfo}
        />
        <CouponExportPopup
          open={this.state.showExportPopup}
          onRequestClose={() => this.setState({ showExportPopup: false })}
          id={this.props.id}
          promoActionType={+this.props.promo_action_type}
          {...offerInfo}
        />
      </div>
    );
  }

}
